import React from 'react';
import { Card, Box, alpha, useTheme } from '@mui/material';

const ModernCard = ({ 
  children, 
  hover = true,
  highlight = false,
  noBorder = false,
  sx = {},
  ...props 
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  return (
    <Card
      elevation={0}
      sx={{
        position: 'relative',
        background: highlight 
          ? alpha(theme.palette.primary.main, isDark ? 0.12 : 0.04)
          : theme.palette.background.paper,
        border: noBorder ? 'none' : `1px solid ${
          highlight 
            ? alpha(theme.palette.primary.main, isDark ? 0.2 : 0.12)
            : theme.palette.divider
        }`,
        transition: 'all 0.2s ease',
        overflow: 'hidden',
        '&:hover': hover ? {
          transform: 'translateY(-2px)',
          boxShadow: `0 4px 24px ${alpha(theme.palette.common.black, isDark ? 0.3 : 0.08)}`,
          border: `1px solid ${
            highlight 
              ? alpha(theme.palette.primary.main, isDark ? 0.3 : 0.2)
              : alpha(theme.palette.common.black, isDark ? 0.2 : 0.08)
          }`,
        } : {},
        ...sx
      }}
      {...props}
    >
      {/* Subtle gradient overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: highlight 
            ? `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)} 0%, transparent 100%)`
            : `linear-gradient(135deg, ${alpha(theme.palette.common.white, isDark ? 0.02 : 0.1)} 0%, transparent 100%)`,
          pointerEvents: 'none',
        }}
      />
      
      {/* Content */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        {children}
      </Box>
    </Card>
  );
};

export default ModernCard; 